import { isLocalhost, env } from '../../../services/dev';
import utils from '../../../services/tools';
import workWxService from './work-wx-service';
import http from '../../../services/http';

export default {
  // 是手机端企业微信
  isMobileWxWork() {
    const ua = navigator.userAgent.toLowerCase();
    // 企业微信
    const isWXWork = /wxwork/i.test(ua);

    // 移动端
    let isMobile = false;
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i,
      )
    ) {
      isMobile = true;
    }
    return isWXWork && isMobile;
  },

  // 通用登录
  commonLogin(noToast) {
    return new Promise((resolve, reject) => {
      if (isLocalhost) {
        // token使用：再企微中本都存储获取；注意：如果为工单需要取的token值为【work_order_token】，其他非工单页面【token】
        // 如果是本地启动，直接使用写死的token
        this.setHttpHeaders({
          token: 'caR3DC6afWMNx_pzur2K3oBPuemoG799',
          userid: 'wmymgKDAAA0DnNk62iEx9Nn6XahU3eHw',
          'Content-Type': 'application/json',
        });

        localStorage.setItem('user_id', 'wmymgKDAAA0DnNk62iEx9Nn6XahU3eHw');
        return resolve();
      }
      workWxService
        .workWxAgentConfig()
        .then(() => {
          this.userLogin(noToast)
            .then((token) => {
              workWxService
                .getCurExternalContactInfo()
                .then((userId) => {
                  this.setHttpHeaders({
                    token,
                    userid: userId,
                    'Content-Type': 'application/json',
                  });
                  localStorage.setItem('user_id', userId);
                  resolve();
                })
                .catch((e) => {
                  console.log(e);
                  if (!noToast) {
                    utils.showError(e);
                  }
                  reject();
                });
            })
            .catch((e) => {
              console.log(e);
              if (!noToast) {
                utils.showError(e);
              }
              reject();
            });
        })
        .catch((e) => {
          console.log('workWxAgentConfig获取失败', e);
          if (!noToast) {
            utils.showError(e);
          }
          reject();
        });
    });
  },

  // 用户登录
  userLogin(noToast) {
    const token = localStorage.getItem('token');
    const tokenGetTime = localStorage.getItem('tokenGetTime');
    const sevenHourTime = 60 * 60 * 8 * 1000;
    const now = new Date().getTime();

    if (token && tokenGetTime) {
      if (sevenHourTime > now - tokenGetTime) {
        return Promise.resolve(token);
      }
    }

    return new Promise((resolve, reject) => {
      const locationSearchParams = utils.getLocationSearchParams();
      if (!locationSearchParams.code) {
        workWxService.getWorkWxAuth();
      } else {
        this.workWxLogin(locationSearchParams.code)
          .then((res) => {
            const { data, err } = utils.getResponseData(res);

            if (err) {
              if (!noToast) {
                utils.showError(err);
              }
              reject(err);
            } else {
              localStorage.setItem('token', data.token);
              localStorage.setItem('tokenGetTime', new Date().getTime());
              localStorage.setItem('nickname', data.nickname);
              localStorage.setItem('oss_account_id', data.oss_account_id);
              resolve(data.token);
            }
          })
          .catch(() => {
            const err = { msg: '登录失败' };
            reject(err);
          });
      }
    });
  },

  setHttpHeaders(headers) {
    http.setCommonHeader({ ...headers });
  },

  // 企业微信code换token
  workWxLogin(code) {
    return http.wwxPost(`${env.apiBase}/wwx/open/wx_login`, { code });
  },
};
